// src/pages/Public/Payment/PublicSuccessPage.js
import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axiosInstance from "../../../utils/axiosInstance";
import backendURL from '../../../config';
import { Box, Typography, Paper, CircularProgress, Alert, Container } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const PaymentSuccessPage = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
    const [message, setMessage] = useState('Verifying your payment, please wait...');

    useEffect(() => {
        const paymentIntentId = searchParams.get('payment_intent');
        
        if (!paymentIntentId) {
            setStatus('error');
            setMessage('Could not find payment details. If you have been charged, please contact support.');
            return;
        }

        const verifyPayment = async () => {
            try {
                await axiosInstance.post(`/verify-payment`, {
                    payment_intent_id: paymentIntentId,
                });
                setStatus('success');
                setMessage('Thank you! Your payment was successful. A receipt has been sent to your email.');
            } catch (err) {
                setStatus('error');
                setMessage(err.response?.data?.message || 'Payment could not be confirmed.');
            }
        };

        verifyPayment();
    }, [searchParams]);

    return (
        <Container component="main" maxWidth="sm" sx={{ mb: 4 }}>
            <Paper variant="outlined" sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 }, textAlign: 'center' }}>
                {status === 'verifying' && (
                    <>
                        <CircularProgress sx={{ mb: 2 }} />
                        <Typography variant="h5">Processing Payment</Typography>
                    </>
                )}
                {status === 'success' && (
                    <>
                        <CheckCircleOutlineIcon sx={{ fontSize: 60, color: 'success.main' }} />
                        <Typography variant="h4" gutterBottom sx={{ mt: 2 }}>
                            Payment Successful!
                        </Typography>
                    </>
                )}
                {status === 'error' && (
                    <>
                        <ErrorOutlineIcon sx={{ fontSize: 60, color: 'error.main' }} />
                        <Typography variant="h4" gutterBottom sx={{ mt: 2 }}>
                            Payment Failed
                        </Typography>
                    </>
                )}
                <Typography variant="body1" sx={{ mt: 2 }}>
                    {message}
                </Typography>
            </Paper>
        </Container>
    );
};

export default PaymentSuccessPage;